import React from 'react'
import { useSelector } from 'react-redux'
import StoreIcon from '@mui/icons-material/Store'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'

function AgentDetailsSection () {
  const selectedApplicationDetails = useSelector(
    state => state.intakeData.selectedApplicationData
  )
  return (
    <div className='flex justify-between items-center w-full wrapper company-agent-details space-x-4'>
      {/* First Section - Company Details */}
      <div className='p-4 w-2/4 company-details'>
        <h3 className='mb-2 text-orange-600 text-xl'>
          <StoreIcon className='mr-2' /> Company Details
        </h3>
        <p>
          <strong>Name: </strong>
          {selectedApplicationDetails?.customer_name || ''}
        </p>
        <p>
          <strong>Contact: </strong>
          {selectedApplicationDetails?.customer_phone || ''}
        </p>
        <p>
          <strong>Email: </strong>{' '}
          {selectedApplicationDetails?.customer_email || ''}
        </p>
        <p className='flex'>
          <strong>Address: </strong>{' '}
          {selectedApplicationDetails?.customer_address || ''}
        </p>
      </div>

      {/* Third Section - Agent Details */}
      <div className='p-4 w-2/4 agent-details'>
        <h3 className='mb-2 text-orange-600 text-xl'>
          <SupportAgentIcon className='mr-2' /> Agent Details
        </h3>
        <p>
          <strong>Name: </strong>
          {selectedApplicationDetails?.agent_name || ''}
        </p>
        <p>
          <strong>Contact: </strong>
          {selectedApplicationDetails?.agent_phone || ''}
        </p>
        <p>
          <strong>Email: </strong>
          {selectedApplicationDetails?.agent_email || ''}
        </p>
        <p className='flex'>
          <strong>Location: </strong>
          {selectedApplicationDetails?.agent_address || ''}
        </p>
      </div>
    </div>
  )
}

export default AgentDetailsSection
